import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiRSelect, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import { toast } from "react-toastify";

import { Table } from 'antd';
import ExportPDFButton from '../../pdf_table.js';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";

export default function VoucherSeries() {
  let navigate = useNavigate();
  const [fy] = useOutletContext();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);







  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .get("/update_voucher_series?delete=" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.data.status == 'success') {
          queryClient.invalidateQueries(['voucher_series'])
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }








  const headers = [
    { label: "Type", key: "type" },
    { label: "Name", key: "name" },
    { label: "Prefix", key: "prefix" },
    { label: "Starting Number", key: "start" },



  ];




  async function fetchData() {

    const { data } = await instance.get(
      "/voucher_series"
    );

    var dataa = data;
    return dataa;
  }

  useEffect(() => {
    queryClient.invalidateQueries(['voucher_series'])
  }, [fy]);

  const seriesModal = useModal('voucher_series');

  const addSeries = (id, row) => {
    seriesModal.show({ id: id, data: row }).then((res) => {
      queryClient.invalidateQueries(['voucher_series'])
    });


  }


  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      onClick: () => addSeries(e.id),
    },
    {
      key: '2',
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];



  const columns = [
    {
      title: 'Type',
      width: '130px',
      dataIndex: 'type',
    },
    {
      title: 'Name',
      width: '130px',
      dataIndex: 'name',
    },
    {
      title: 'Prefix',
      width: '80px',
      dataIndex: 'prefix',
    },
    {
      title: 'Starting No',
      width: '80px',
      dataIndex: 'start',
    },



    {
      title: '',
      fixed: 'right',
      width: '40px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
            items: items(row),
          }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>


          </Dropdown>

        </div>


      )
    },

  ];




  const { data, error, isError, isLoading, isFetching } = useQuery(["voucher_series", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  const pdf_columns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Prefix',
      dataIndex: 'prefix',
      key: 'prefix',
    },
    {
      title: 'Starting No',
      dataIndex: 'start',
      key: 'start',
    },


  ];




  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Voucher Series
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Voucher Series" >

            {data.items &&
              <>
                <ExportPDFButton columns={pdf_columns} data={data.items} title="voucher-series" />
                <CSVLink data={data.items} filename={"Voucher-Series.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }
            <UiButton className="btn btn-primary" onClick={() => addSeries('new')} title="Add" icon="add" ></UiButton>


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4">






            <Table
              locale={{
                emptyText: (<TableZero title="Series" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              loading={{ spinning: (tableDisable || isFetching) }}
              scroll={{
                x: 960,

              }}
            />

          </div>

        </div>
      </div>
    </>
  );
}
